<template>
    <div class="listSearch">
        <!-- 分页列表 查询+表格 组件 -->
        <div class="header">
            <div class="buttons">
                <slot name="buttons"></slot>
            </div>
            <div class="search">
                <el-form :inline="true" @submit.native.prevent>
                    <slot name="forms"></slot>
                </el-form>
            </div>
        </div>
        <div class="mid" style="width: 100%;">
            <slot name="list" :tableData="tableData" :loading="loading"></slot>
        </div>
        <div class="footer" v-if="!hidePage">
            <el-pagination
                @size-change="handleSize"
                @current-change="updateData"
                :current-page.sync="currentPage"
                :page-sizes="pageSizes"
                :page-size="currentSize"
                :layout="layout"
                :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 查询所需字段
        formSearch: {
            type: Object,
            default() {
                return {};
            }
        },
        // 是否隐藏分页
        hidePage: {
            type: Boolean,
            default: false
        },
        layout: {
            type: String,
            default: 'total, sizes, prev, pager, next, jumper'
        },
        pageSizes: {
            type: Array,
            default() {
                return [10, 20, 30, 40];
            }
        }
    },
    data() {
        return {
            loading: false, // 表格是否在加载
            resetSearch: null, // 重置数据
            currentPage: 1, // 当前页码
            currentSize: 10, // 当前每页数量
            total: 0, // 总数据量
            tableData: [] // 数据列表
            
        };
    },
    created() {
        this.currentSize = this.pageSizes[0];
        this.resetSearch = Object.assign({}, this.formSearch);
    },
    methods: {
        // 查询
        search() {
            this.currentPage = 1;
            this.updateData();
        },
        // 重置
        reset() {
            this.$parent.formSearch = Object.assign({}, this.resetSearch);
            this.search();
        },
        // 更新父组件数据
        updateData() {
            this.loading = true;
            this.$parent
                .getList(this.currentPage - 1, this.currentSize)
                .then(res => {
                    this.loading = false;
                    switch (true) {
                        case Array.isArray(res):
                            this.tableData = res;
                            break;
                        default:
                            this.total = Number(res.totalElements);
                            this.tableData = res.content;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.tableData = [];
                })
        },
        // 更改分页数量时
        handleSize(val) {
            this.currentSize = val;
            this.search();
        }
    }
};
</script>

<style lang="scss">
.listSearch {
    .header {
        display: flex;
        justify-content: space-between;
        & > .buttons {
            margin-right: 30px;
            .el-button {
                margin-bottom: 20px;
            }
            .title {
                font-size: 18px;
                line-height: 32px;
                color: $primary;
                margin-bottom: 20px;
            }
        }
        .search {
            flex: 1;
            text-align: right;
            .buttons {
                display: inline-block;
                margin-bottom: 20px;
                margin-left: 30px;
            }
            .el-form--inline .el-form-item {
                margin-right: 0;
                margin-left: 30px;
            }
        }
    }
    .mid {
        .el-table th {
            background-color: #F6F9FD;
        }
    }
    .footer {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
